import { Dialog } from "primereact/dialog";
import { FileUpload } from "primereact/fileupload";
import { useState } from "react";
import { uploadBdxForPerilBreakdown } from "../../api/routes";
import { useToast } from "../../context-providers/Toast";
import { downloadBlob } from "../../util";
import styles from "./BdxPerilBreakdownModal.module.css";

type BdxPerilBreakdownModalProps = {
  visible: boolean;
  setVisible: (value: boolean) => void;
};

export const BdxPerilBreakdownModal: React.FC<BdxPerilBreakdownModalProps> = ({
  visible,
  setVisible,
}) => {
  const toast = useToast();
  const [isProcessing, setIsProcessing] = useState(false);

  return (
    <Dialog
      header="BDX Peril Breakdown"
      visible={visible}
      onHide={() => setVisible(false)}
      className={styles.dialog}
    >
      <p className={styles.description}>
        Upload a reinsurer BDX (.xlsx) to get it back with per-peril premium
        columns appended. The reinsurer is detected from the file name, and each
        row&apos;s premium is validated against the matching report&apos;s
        enabled layer before anything is written.
      </p>
      <FileUpload
        auto
        mode="basic"
        customUpload
        disabled={isProcessing}
        accept=".xlsx"
        chooseLabel={isProcessing ? "Processing..." : "Upload BDX"}
        chooseOptions={{ className: "p-button-raised" }}
        uploadHandler={async (e) => {
          const file = e.files[0];
          e.options.clear();
          if (!file) {
            return;
          }
          try {
            setIsProcessing(true);
            const { data, filename, warnings } =
              await uploadBdxForPerilBreakdown(file);
            downloadBlob(
              filename ??
                `${file.name.replace(/\.xlsx$/i, "")} - peril breakdown.xlsx`,
              data
            );
            if (warnings?.length) {
              toast.show({
                severity: "warn",
                summary: "BDX processed with warnings",
                detail: warnings.join("\n"),
                sticky: true,
                className: styles.rowListToast,
              });
            }
            setVisible(false);
          } catch (error) {
            toast.show({
              severity: "error",
              summary: "BDX processing failed",
              detail: error instanceof Error ? error.message : String(error),
              sticky: true,
              className: styles.rowListToast,
            });
          } finally {
            setIsProcessing(false);
          }
        }}
      />
    </Dialog>
  );
};
